import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { QuickViewModalComponent } from "./quick-view-modal.component";

@NgModule({
  declarations: [QuickViewModalComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [QuickViewModalComponent],
})
export class QuickViewModalModule {}
